import { GridColDef } from '@mui/x-data-grid';
import { Button } from '@mui/material';
import { AdSpaceMediaTypeInterface } from '../../../interfaces/interfaces';

export const getAdSpaceMediaTypesColumns = (
  setMediaTypeToDelete: (mediaType: AdSpaceMediaTypeInterface) => void,
  setDeleteDialogOpen: (open: boolean) => void,
  setMediaTypeToUpdate: (mediaType: AdSpaceMediaTypeInterface) => void,
  setUpdateDialogOpen: (open: boolean) => void
): GridColDef[] => [
  { field: 'id', headerName: 'ID', width: 70 },
  { field: 'name', headerName: 'Name', width: 200 },
  { field: 'description', headerName: 'Description', width: 300 },
  { field: 'active', headerName: 'Active', width: 90, type: 'boolean' },
  { field: 'created_at', headerName: 'Created', width: 150 },
  { field: 'updated_at', headerName: 'Updated', width: 150 },
  {
    field: 'delete',
    headerName: 'Delete',
    width: 100,
    renderCell: (params) => (
      <Button
        color="error"
        variant="outlined"
        size="small"
        onClick={() => {
          setMediaTypeToDelete(params.row);
          setDeleteDialogOpen(true);
        }}
      >
        Delete
      </Button>
    ),
    sortable: false,
    filterable: false,
  },
  {
    field: 'update',
    headerName: 'Update',
    width: 100,
    renderCell: (params) => (
      <Button
        color="primary"
        variant="outlined"
        size="small"
        onClick={() => {
          setMediaTypeToUpdate(params.row);
          setUpdateDialogOpen(true);
        }}
      >
        Update
      </Button>
    ),
    sortable: false,
    filterable: false,
  },
];